import '@modifi/plugin-countries/register'
import '@modifi/plugin-documents/register'
import '@modifi/plugin-banners/register'
import {init as i18nInit} from '@modifi/plugin-i18n/register'

export const initPlugins = (options = {}) =>
  Promise.all([i18nInit(options?.i18n)]).then(() => {
    import('@modifi/plugin-onboarding/register')
  })
